<template>
  <Authenticated>
    <VouchersModal :show="accountShowModal" :account="currentAccount" @save="saveAccount" />
    <div>
      <button @click="showAccount(currentAccount)" class="action-buttons action-colour"><font-awesome-icon icon="plus" /> Add Voucher</button>
      <div class="actions">
        <h2 @click="getAccounts">Vouchers</h2>
      </div>

      <div class="search-sort-layout">
        <form role="search" class="search">
          <input id="search" type="search" placeholder="Search..." autofocus required v-model="searchQuery" />
          <!-- <button @click="search()" type="submit">Go</button> -->
        </form>
        <div class="filtered">
          <label for="filtered">View Used Vouchers</label>
          <input id="filtered" type="checkbox" v-model="filtered" />
        </div>
        <div class="sort-dropdown">
          <Carousel :items="sortOptions" :selected="sortOption" title="Sort By" @select-item="selectSort" />
        </div>
      </div>
      <h2 v-if="noResults">No Vouchers Found</h2>
      <h2 v-if="searchQuery && searches.length">Searches:</h2>
      <ul v-if="searches.length" class="table wrapper layout content-gap">
        <template v-bind:key="search" v-for="search in filtered ? searches : searches.filter((v) => v.value > 0)">
          <li @click="showAccount(search)" class="modifierBox">
            <div class="box">
              <p>
                <span class="modifier-name">{{ search.key[1] }}</span>
                <span class="modifier-name">{{ search.key[0] }}</span>
                <CurrencyFormatter :value="search.value" :currency="currency" />
              </p>
              <span></span>
            </div>
          </li>
        </template>
      </ul>

      <ul class="table wrapper layout content-gap">
        <template v-bind:key="account" v-for="account in filtered ? accounts : accountsFiltered">
          <li @click="showAccount(account)" class="modifierBox">
            <div class="box">
              <p>
                <span class="modifier-name">{{ account.key[1] }}</span>
                <span class="modifier-name">{{ account.key[0] }}</span>
                <CurrencyFormatter :value="account.value" :currency="currency" />
              </p>
              <span></span>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </Authenticated>
</template>
<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { mapGetters } from "vuex";
import VouchersModal from "@/components/Vouchers/VouchersModal";
import { api } from "@monolith/helpers";
import { Carousel, CurrencyFormatter } from "@monolith/components";

export default {
  name: "Accounts",
  components: {
    Authenticated,
    VouchersModal,
    Carousel,
    CurrencyFormatter,
  },
  data() {
    return {
      filtered: false,
      currentAccount: {},
      showAddAccount: false,
      accountRoute: false,
      showAccountModal: false,
      searchQuery: "",
      searches: [],
      noResults: false,
      sortOption: "",
      sortedAccounts: [],
      sortOptions: [
        { name: "Default", value: "default", selected: true },
        { name: "Name", value: "name" },
        { name: "ID", value: "id" },
        { name: "Desc Balance", value: "htl" },
        { name: "Asc Balance", value: "lth" },
      ],
    };
  },
  mounted() {
    if (this.$route.params.account) {
      this.accountRoute = true;
    }
    this.$store.commit("currPage", "vouchers");
  },
  computed: {
    accountShowModal() {
      if (this.accountRoute) {
        return true;
      } else {
        return this.showAccountModal;
      }
    },
    ...mapGetters({
      modifier_sets: "modifier_sets",
      accounts: "vouchers",
      accountsFiltered: "vouchersFiltered",
      currency: "currency",
    }),
  },
  watch: {
    sortOption: function (val) {
      if (val === "name") {
        this.accounts.sort((a, b) => {
          return a.key[1].localeCompare(b.key[1]);
        });
      } else if (val === "htl") {
        this.accounts.sort((a, b) => {
          return b.value - a.value;
        });
      } else if (val === "lth") {
        this.accounts.sort((a, b) => {
          return a.value - b.value;
        });
      } else if (val === "id") {
        this.accounts.sort((a, b) => {
          return a.key[0] - b.key[0];
        });
      } else {
        this.accounts.sort((a, b) => {
          return a.key[0].localeCompare(b.key[0]);
        });
      }
    },
    searchQuery: function () {
      this.search();
    },
  },
  methods: {
    async search() {
      if (this.searchQuery.length > 1) {
        const search = await api.searchVouchers(this.searchQuery);
        let result = search.rows.map((acc) =>
          acc.key[2] == "id-name" ? { key: [acc.key[0], acc.key[1]], value: acc.value } : { key: [acc.key[1], acc.key[0]], value: acc.value },
        );
        !result.length ? (this.noResults = true) : (this.noResults = false);
        this.searches = result;
      } else {
        this.noResults = false;
        this.searches = [];
        document.querySelector(".sort-dropdown").style.display = "flex";
      }
    },
    selectSort(val) {
      this.sortOption = val.value;
      if (val === "name") {
        this.accounts.sort((a, b) => {
          return a.key[1].localeCompare(b.key[1]);
        });
      } else if (val === "htl") {
        this.accounts.sort((a, b) => {
          return b.value - a.value;
        });
      } else if (val === "lth") {
        this.accounts.sort((a, b) => {
          return a.value - b.value;
        });
      } else if (val === "id") {
        this.accounts.sort((a, b) => {
          return a.key[0] - b.key[0];
        });
      } else {
        this.accounts.sort((a, b) => {
          return a.key[0].localeCompare(b.key[0]);
        });
      }
    },
    accountHistory(account) {
      this.$store.dispatch("voucherHistory", account);
      //this.channel.push("account:history", id, name);
    },
    showAccount(account) {
      if (account.key) {
        this.accountHistory(account.key);
        this.currentAccount = {
          ID: account.key[0],
          name: account.key[1],
          value: account.value,
          new: true,
        };
      } else {
        this.currentAccount = {
          ID: "",
          name: "",
          doc_type: "credit",
          value: 0,
          date: new Date().toISOString(),
        };
      }

      this.showAccountModal = !this.showAccountModal;
    },
    saveAccount() {
      let voucher = {
        _id: "product:vouchers" + this.currentAccount.ID,
        id: "product:vouchers" + this.currentAccount.ID,
        modifiers: {},
        price: this.currentAccount.value,
        hash: "",
        name: "voucher-" + this.currentAccount.ID,
        value: { _id: "product:vouchers" + this.currentAccount.ID, name: "product:vouchers" + this.currentAccount.ID },
      };
      this.$store.dispatch("addProduct", voucher);
      this.$store.dispatch("addToCart", voucher);
      this.channel.push("voucher:doc", this.currentAccount);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

h2 {
  margin: 1rem;
}

.search-sort-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 0 0;
  .filtered {
    display: flex;
    align-items: center;
    input {
      width: 1rem;
      height: 1rem;
      color: var(--action-colour);
    }
  }
  .search {
    background: var(--secondary-colour);
    color: var(--warning-colour);
    margin-left: 1rem;
    #search {
      border: none;
      height: 3rem;
    }
  }

  .fa-sort {
    font-size: 2rem;
  }
  .sort-dropdown {
    display: flex;
    align-items: center;
    select {
      height: 3rem;
      font-size: 1.5rem;
      padding: 0.5rem;
      border-radius: 0.5rem;
      border: 1px solid var(--secondary-colour);
      background-color: var(--secondary-colour);
    }
  }
}

@media only screen and (orientation: portrait) {
  .search-sort-layout {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 0 0 1rem;

    .filtered {
      margin: auto;
    }

    .sort-dropdown {
      margin: auto;
      h2 {
        min-width: 0rem;
      }
    }
  }
}
</style>
